
const Pagina404: React.FC = () => {
  return <></>; 
};

export default Pagina404;
